/** Backtests list. */
import { Shell } from "../components/Shell.tsx";
import { Empty, Loading, Page } from "../components/ui.tsx";
import { useApi } from "../lib/data.ts";
import { dateUtc, pct, usd0 } from "../lib/format.ts";
import { Link, navigate } from "../lib/router.tsx";
import type { BacktestRow, StrategyRow } from "../lib/types.ts";

export function Backtests() {
  const { data, loading } = useApi<{ backtests: BacktestRow[] }>("/backtests", { refreshMs: 5000 });
  const { data: st } = useApi<{ strategies: StrategyRow[] }>("/strategies");
  const nameOf = (v: string) => st?.strategies.find((s) => s.version_id === v)?.name ?? (v.startsWith("tpl:") ? v.slice(4).split("@")[0] : "Strategy");
  return (
    <Shell crumb="Strategies · Backtests">
      <Page eyebrow="Strategies" title="Backtests" width={1100}>
        {loading ? <Loading /> : !data!.backtests.length ? <Empty title="No backtests yet">Open the <Link to="/strategies">library</Link> and press Backtest on any strategy.</Empty> : (
          <div className="card overflow-x-auto">
            <table className="table min-w-[720px]">
              <thead><tr><th>Strategy</th><th>Period</th><th>Status</th><th className="text-right">Final</th><th className="text-right">Per year</th><th className="text-right">Worst drop</th></tr></thead>
              <tbody>{data!.backtests.map((b) => (
                <tr key={b.id} className="cursor-pointer hover:bg-soft/60" onClick={() => navigate(`/backtests/${b.id}`)}>
                  <td><Link to={`/backtests/${b.id}`} className="font-medium text-ink-strong">{nameOf(b.version_id)}</Link></td>
                  <td className="text-muted">{dateUtc(b.period_from)} → {b.period_to ? dateUtc(b.period_to) : "now"} · {usd0(b.capital)}</td>
                  <td>{b.status === "done" ? <span className="text-ok-ink">Done</span> : b.status === "failed" ? <span className="text-warn-ink">Failed</span> : <span className="chip">{b.status === "running" ? "Running…" : "Queued…"}</span>}</td>
                  <td className="num text-right">{b.summary ? usd0(b.summary.final) : "—"}</td>
                  <td className={`num text-right ${b.summary && b.summary.cagrPct >= 0 ? "up" : "down"}`}>{b.summary ? pct(b.summary.cagrPct) : "—"}</td>
                  <td className="num text-right">{b.summary ? pct(b.summary.maxDdPct) : "—"}</td>
                </tr>))}
              </tbody>
            </table>
          </div>
        )}
      </Page>
    </Shell>
  );
}
